import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import { Box, Button, Divider } from "@mui/material";
import { FRACTIONS } from "../models/qualityCheck";

const DIGITS = [..."789456123.0", "Backspace"];
const STEPS = ["-1/32", "+1/32"];

const LABELS: Record<string, string> = {
	Backspace: "Delete last digit",
	".": "Decimal point",
	Clear: "Clear point",
	"-1/32": "Minus one thirty-second",
	"+1/32": "Plus one thirty-second",
};

// Digits | fractions, both always on screen. Landscape (`column`): 3 fraction
// columns, the steps move under the digits and Next point spans the bottom.
export const MeasurementKeypad = ({
	column,
	disabled,
	onKey,
}: {
	column: boolean;
	disabled: boolean;
	onKey: (key: string) => void;
}) => {
	const key = (k: string) => (
		<Button
			key={k}
			variant="outlined"
			color={k.includes("/") ? "primary" : "inherit"}
			disabled={disabled}
			aria-label={LABELS[k] ?? k}
			onClick={() => onKey(k)}
			sx={{
				minWidth: 0,
				p: 0,
				fontSize: k.includes("/") ? (STEPS.includes(k) ? 15 : 18) : 26,
				fontWeight: k.includes("/") ? 700 : 400,
				borderColor: k.includes("/") ? "#2e7d3266" : "divider",
				textTransform: "none",
				touchAction: "manipulation",
			}}
		>
			{k === "Backspace" ? (
				<BackspaceOutlinedIcon />
			) : k === "Clear" ? (
				"C"
			) : (
				k.replace("-", "−")
			)}
		</Button>
	);
	const next = (
		<Button
			variant="contained"
			disabled={disabled}
			onClick={() => onKey("next")}
			sx={{ gridColumn: "span 3", minWidth: 0, minHeight: 52, fontSize: 15 }}
		>
			Next point →
		</Button>
	);
	const rows = column ? 5 : 4;
	const grid = (columns: number) => ({
		flex: columns,
		display: "grid",
		gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
		gridTemplateRows: `repeat(${rows}, minmax(52px, 1fr))`,
		gap: 0.75,
	});
	return (
		<Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.75 }}>
			<Box sx={{ flex: 1, display: "flex", gap: 1 }}>
				<Box sx={grid(3)}>
					{(column ? [...DIGITS, "Clear", ...STEPS] : DIGITS).map(key)}
				</Box>
				<Divider orientation="vertical" flexItem />
				<Box sx={grid(column ? 3 : 5)}>
					{column ? FRACTIONS.map(key) : [...FRACTIONS, ...STEPS].map(key)}
					{!column && next}
				</Box>
			</Box>
			{column && next}
		</Box>
	);
};
